import _, {
  each,
  map,
  mapKeys,
  values,
} from 'lodash';

interface ITopic {
    id: string;
    name: string;
    checked?: boolean;
}

interface ITopicData {
    topicId: number;
    category: string;
    subCategory: string;
}


const returnTopic = (item) => {
    switch(item)  {
        case "BUSINESS" :{
            return businessCheckBoxItems
        };
        case "FINANCE":{
            return financialCheckboxData
        };
        case "CAREER":{
            return careerCheckboxData
        };
        case "LIFESTYLE":{
            return lifeCycleCheckboxData
        };
        case "MINDSET":{
            return mindsetCheckboxData
        };
    }
}

const businessCheckBoxItems = [
    {
        id: "category.Business.marketing",
        name: "Marketing",
    },
    {
        id: "category.Business.e-commerce",
        name: "E-Commerce",
    },
    {
        id: "category.Business.web-mobile-design",
        name: "Web & Mobile Design",
    },
    {
        id: "category.Business.entrepreneurship",
        name: "Entrepreneurship",
    },
    {
        id: "category.Business.communications",
        name: "Communications",
    },
    {
        id: "category.Business.leadership-teamwork",
        name: "Leadership & Teamwork",
    },
    {
        id: "category.Business.sales",
        name: "Sales",
    },
    {
        id: "category.Business.customer-service",
        name: "Customer Service",
    },
    {
        id: "category.Business.management",
        name: "Management",
    },
    {
        id: "category.Business.human-resources",
        name: "Human Resources",
    },
    {
        id: "category.Business.operations",
        name: "Operations",
    },
    {
        id: "category.Business.business-software",
        name: "Business Software",
    },
    {
        id: "category.Business.business-analysis-strategies",
        name: "Business Analysis & Strategies",
    },
];
const financialCheckboxData = [
    {
        id: "category.Finance.financial-freedom",
        name: "Financial Freedom",
    },
    {
        id: "category.Finance.investing",
        name: "Investing",
    },
    {
        id: "category.Finance.passive-income",
        name: "Passive Income",
    },
    {
        id: "category.Finance.accounting",
        name: "Accounting",
    },
    {
        id: "category.Finance.finance",
        name: "Finance",
    },
    {
        id: "category.Finance.banking-budgeting-wealth-management",
        name: "Banking, Budgeting & Wealth Management",
    },
    {
        id: "category.Finance.credit-rating-loans-mortgages",
        name: "Credit Rating, Loans & Mortgages",
    },
    {
        id: "category.Finance.taxes",
        name: "Taxes",
    },
    {
        id: "category.Finance.cyrptocurrency-blockchain",
        name: "Cyrptocurrency & Blockchain",
    },
    {
        id: "category.Finance.real-estate",
        name: "Real Estate",
    },
    {
        id: "category.Finance.finance-certification-test-prep",
        name: "Finance Certification & Test Prep",
    },
    {
        id: "category.Finance.money-management-tools",
        name: "Money Management Tools",
    },
];
const careerCheckboxData = [
    {
        id: "category.Career.resumes",
        name: "Resumes",
    },
    {
        id: "category.Career.interviewing",
        name: "Interviewing",
    },
    {
        id: "category.Career.networking",
        name: "Networking",
    },
    {
        id: "category.Career.career-path",
        name: "Career Path",
    },
    {
        id: "category.Career.career-consulting",
        name: "Career Consulting",
    },
    {
        id: "category.Career.retirement",
        name: "Retirement",
    },
    {
        id: "category.Career.side-hustles",
        name: "Side Hustles",
    },
    {
        id: "category.Career.freelancing",
        name: "Freelancing",
    },
    {
        id: "category.Career.remote-working",
        name: "Remote Working",
    },
    {
        id: "category.Career.youTube-podcasts-selfPublishing",
        name: "YouTube, Podcasts & Self-Publishing",
    },
    {
        id: "category.Career.job-offer-negotiations",
        name: "Job Offer Negotiations",
    },
    {
        id: "category.Career.performance-reviews-salary-negotiations",
        name: "Performance Reviews & Salary Negotiations",
    },
    {
        id: "category.Career.job-changes-and-resignation",
        name: "Job Changes and Resignation",
    },
    {
        id: "category.Career.certification-prep",
        name: "Certification & Prep",
    },
];
const mindsetCheckboxData = [
    {
        id: "category.Mindset.motivational",
        name: "Motivational",
    },
    {
        id: "category.Mindset.anxiety",
        name: "Anxiety",
    },
    {
        id: "category.Mindset.relationships",
        name: "Relationships",
    },
    {
        id: "category.Mindset.morning-routines",
        name: "Morning Routines",
    },
    {
        id: "category.Mindset.stress-management",
        name: "Stress Management",
    },
    {
        id: "category.Mindset.self-esteem",
        name: "Self-Esteem",
    },
    {
        id: "category.Mindset.mid-life-management",
        name: "Mid-Life Management",
    },
    {
        id: "category.Mindset.mindfulness",
        name: "Mindfulness",
    },
    {
        id: "category.Mindset.meditation",
        name: "Meditation",
    },
    {
        id: "category.Mindset.new-age",
        name: "New Age",
    },
    {
        id: "category.Mindset.spiritual",
        name: "Spiritual",
    },
    {
        id: "category.Mindset.psychology-neuroscience",
        name: "Psychology & Neuroscience",
    },
    {
        id: "category.Mindset.personal-transformation",
        name: "Personal Transformation",
    },
    {
        id: "category.Mindset.productivity",
        name: "Productivity",
    },
    {
        id: "category.Mindset.time-management",
        name: "Time Management",
    },
    {
        id: "category.Mindset.memory-study-skills",
        name: "Memory & Study Skills",
    },
];
const lifeCycleCheckboxData = [
    {
        id: "category.Lifestyle.health",
        name: "Health",
    },
    {
        id: "category.Lifestyle.healthy-cooking-eating",
        name: "Healthy Cooking & Eating",
    },
    {
        id: "category.Lifestyle.home",
        name: "Home",
    },
    {
        id: "category.Lifestyle.diet",
        name: "Diet",
    },
    {
        id: "category.Lifestyle.fitness",
        name: "Fitness",
    },
    {
        id: "category.Lifestyle.parenting",
        name: "Parenting",
    },
    {
        id: "category.Lifestyle.mental-health",
        name: "Mental Health",
    },
    {
        id: "category.Lifestyle.sleep",
        name: "Sleep",
    },
    {
        id: "category.Lifestyle.languages",
        name: "Languages",
    },
    {
        id: "category.Lifestyle.travel",
        name: "Travel",
    },
    {
        id: "category.Lifestyle.habits",
        name: "Habits",
    },
    {
        id: "category.Lifestyle.arts-crafts-hobbies",
        name: "Arts, Crafts, & Hobbies",
    },
    {
        id: "category.Lifestyle.beauty-style",
        name: "Beauty & Style",
    },
    {
        id: "category.Lifestyle.fasting",
        name: "Fasting",
    },
];

const classesKeywords = [
    {
        id: "1",
        name: "Business Analyst",
    },
    {
        id: "2",
        name: "Branding",
    },
    {
        id: "3",
        name: "UX",
    },
    {
        id: "4",
        name: "Website Development",
    },
];

const checkedArray = (arr: ITopicData[]) =>
    map(
        arr,
        (d: ITopicData) => "category." + _.upperFirst(_.toLower(d.category)) + "." + d.subCategory
    );

const arrayToObjectKey = (arr: ITopic[]) => {
    return mapKeys(arr, "id");
};

const returnCheckedData = (topics: ITopic[]) => {
    return (arr: ITopicData[]): ITopic[] => {
        const checkedArr = checkedArray(arr);
        const t = _.cloneDeep(arrayToObjectKey(topics));

        each(checkedArr, (d: string) => {
            if (t[d]) {
                t[d].checked = true;
            }
        });

        return values(t);
    };
};

const returnCheckedBusinessData = returnCheckedData(businessCheckBoxItems);
const returnCheckedFinancialData = returnCheckedData(financialCheckboxData);
const returnCheckedCareerData = returnCheckedData(careerCheckboxData);
const returnCheckedMindsetData = returnCheckedData(mindsetCheckboxData);
const returnCheckedLifeCycleData = returnCheckedData(lifeCycleCheckboxData);

export {
  businessCheckBoxItems,
  careerCheckboxData,
  classesKeywords,
  financialCheckboxData,
  lifeCycleCheckboxData,
  mindsetCheckboxData,
  returnCheckedBusinessData,
  returnCheckedCareerData,
  returnCheckedFinancialData,
  returnCheckedLifeCycleData,
  returnCheckedMindsetData,
  returnTopic,
};
